import React from "react";
import "./Review.scss";

export const Star = ({ style = null }) => {
  return (
    <div className="fdn-star-container">
      <span className="fdn-star-on-png" style={style} />
    </div>
  );
};

const StarRating = ({ rating, className }) => {
  var stars = [];
  let completeStars = Math.floor(rating);
  for (var i = 0; i < completeStars; i++) {
    stars.push(<Star key={i} />);
  }
  if (rating % 1 > 0) {
    stars.push(<Star key="last" style={{ width: `${(rating % 1) * 100}%` }} />);
  }

  const classes = ["fdn-rating", className].filter(Boolean).join(" ");

  return (
    <div className={classes}>
      <div className="fdn-stars">{stars}</div>
    </div>
  );
};

export default StarRating;



// WEBPACK FOOTER //
// ./src/components/StarRating.js